import { createFileRoute } from "@tanstack/react-router";
import AdminThemes from "@/pages/admin/AdminThemes";

export const Route = createFileRoute("/_adminLayout/admin/themes")({
  head: () => ({ meta: [
    { title: "Site Themes | Rex & Sons RVs Admin" },
    { name: "description", content: "Manage Rex & Sons RVs layouts, seasonal theme packs and live theme selection." },
    { property: "og:title", content: "Site Themes | Rex & Sons RVs Admin" },
    { property: "og:description", content: "Manage layouts, seasonal theme packs and live theme selection for Rex & Sons RVs." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { name: "robots", content: "noindex" },
  ] }),
  component: AdminThemes,
});
